import React from 'react';
import { Helmet } from 'react-helmet-async';
import useSsrWindowLocation from 'app/hook/common/useSsrWindowLocation';
import useSsrUserAgent from 'app/hook/common/useSsrUserAgent';

const HeadInfo = ({
	headTitle = '',
	headTitleCustom = '',
	metaDescription = '내 차, 판매부터 구매까지. 중고차는 엔카믿고 함께해요.',
	metaKeywords = '',
	metaUrl = '',
	metaImage = '',
	headTitleEstimate = undefined,
	metaViewportZoom = false,
	metaRobots = null,
	metaThemeColor = '#ffffff',
	linkCanonical = null,
	alternate = {
		link: '',
		media: 768,
	},
}) => {
	const location = useSsrWindowLocation();
	const ua = useSsrUserAgent();
	const renderHeadTitle = () => {
		if (headTitle) {
			return <title>{`${headTitle} : 내차팔기·내차사기`}</title>;
		}
		if (headTitleCustom) {
			return <title>{headTitleCustom}</title>;
		}
		return null;
	};
	const renderMetaHeadTitle = () => {
		if (headTitle) {
			return (
				<meta
					property="og:title"
					content={`${headTitle} : 내차팔기·내차사기`}
				/>
			);
		}
		if (headTitleCustom) {
			return (
				<meta
					property="og:title"
					content={headTitleCustom}
				/>
			);
		}
		return null;
	};
	return (
		<Helmet>
			{
				// 테스트 서버에서의 검색 크롤러 차단
				process.env.REACT_APP_DEPLOY_ENV !== 'prod' && (
					<meta
						name="robots"
						content="noindex"
					/>
				)
			}
			{renderHeadTitle()}
			{renderMetaHeadTitle()}
			{headTitleEstimate != null && <title>내차시세조회 | 엔카 - No.1 엔카가 만든 최고가 내차팔기</title>}
			{/* { // 광고 기간 중 주석처리
				(headTitleEstimate != null) && <title>{`엔카비교견적 ${headTitleEstimate} - No.1 엔카가 만든 최고가 내차팔기`}</title>
			} */}
			{headTitleEstimate != null && (
				<meta
					property="og:title"
					content="내차시세조회 | 엔카 - No.1 엔카가 만든 최고가 내차팔기"
				/>
			)}
			{/* { // 광고 기간 중 주석처리
				(headTitleEstimate != null) && <meta property="og:title" content={`엔카비교견적 ${headTitleEstimate} - No.1 엔카가 만든 최고가 내차팔기`} />
			} */}
			{metaDescription && (
				<meta
					name="description"
					content={metaDescription}
				/>
			)}
			{metaDescription && (
				<meta
					property="og:description"
					content={metaDescription}
				/>
			)}
			{metaKeywords && (
				<meta
					name="keywords"
					content={metaKeywords}
				/>
			)}
			{metaUrl && (
				<meta
					property="og:url"
					content={metaUrl}
				/>
			)}
			{/**
				viewport 설정
			 	- true, false로 전달시 1.0, 5.0 확대 여부사용
			 	- 메타태그 전달시 커스텀 적용 ex) metaViewportZoom={isPc ? <meta name="viewport" content="" /> : false}
			*/}
			{!metaViewportZoom && (
				<meta
					name="viewport"
					content="user-scalable=no,initial-scale=1,maximum-scale=1,minimum-scale=1,width=device-width"
				/>
			)}
			{metaViewportZoom && typeof metaViewportZoom === 'boolean' && (
				<meta
					name="viewport"
					content="user-scalable=yes,initial-scale=1.0,maximum-scale=5.0,minimum-scale=1.0,width=device-width"
				/>
			)}
			{metaViewportZoom && typeof metaViewportZoom === 'object' && metaViewportZoom}
			{metaRobots && (
				<meta
					name="robots"
					content={metaRobots}
				/>
			)}
			{linkCanonical && (
				<link
					rel="canonical"
					href={linkCanonical}
				/>
			)}
			{alternate && ua().isPc && (
				<link
					rel="alternate"
					href={alternate.link}
					media={`only screen and (max-width: ${alternate.media || 768}px)`}
				/>
			)}
			<meta
				name="theme-color"
				content={metaThemeColor}
			/>
			<meta
				property="og:image"
				content={metaImage || `${location.protocol}//${location.host}/assets/images/common/brand_logo_400x400_v2.jpg`}
			/>
			<meta
				property="og:site_name"
				content="엔카"
			/>
			<meta
				property="og:locale"
				content="ko_KR"
			/>
		</Helmet>
	);
};

HeadInfo.displayName = 'HeadInfo';

export default HeadInfo;
